"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Property = void 0;
const GeoModelCommon_1 = require("./Geo/GeoModelCommon");
const commonAttributeSets_1 = require("./commonAttributeSets");
const selectedConfig_1 = require("../selectedConfig");
const typeName = 'Property';
class Property extends GeoModelCommon_1.GeoModelCommon {
    constructor({ dwellingNumber, streetName, postcode, ...ob }) {
        super({ ...ob, type: ob.type || typeName });
        this.dwelling_number = ob.dwelling_number ?? dwellingNumber ?? '';
        this.street_name = ob.street_name ?? streetName ?? '';
        this.suburb = ob.suburb ?? '';
        this.city = ob.city ?? '';
        this.country = ob.country ?? '';
        this.post_code = ob.post_code ?? postcode ?? '';
    }
    // get streetName() {
    //   return this.street_name
    // }
    // get dwellingNumber() {
    //   return this.dwelling_number
    // }
    // get postcode() {
    //   return this.post_code
    // }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            // iD: { type: 'UNKNOWN', editable: true, label: 'ID', name: 'iD' },
            // name: { type: 'UNKNOWN', editable: true, label: 'Name', name: 'name' },
            // address: { type: 'UNKNOWN', editable: true, label: 'Address', name: 'address' },
            name: {
                type: 'String',
                editable: true,
                required: true,
                label: 'Property Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
            description: { type: 'String', editable: true, label: 'Description', description: 'description' },
            ...commonAttributeSets_1.Address,
            location_lat: { ...super.getUserAttributes().location_lat, hidden: true },
            location_lng: { ...super.getUserAttributes().location_lng, hidden: true },
            tz: {
                label: 'Timezone',
                type: 'Enum',
                editable: true,
                enumKv: Object.fromEntries(selectedConfig_1.supportedTZs.map((tz) => [tz, tz])),
                required: true,
                default: Intl.DateTimeFormat().resolvedOptions().timeZone,
                hideFromList: true,
            },
            //
            // dwellingNumber: { type: 'String', editable: true, label: 'Dwelling Number', description: 'Dwelling Number' },
            // streetName: { type: 'String', editable: true, label: 'Street Number & Name', description: 'street name' },
            // suburb: { type: 'String', editable: true, label: 'Suburb' },
            // city: { type: 'String', editable: true, label: 'City' },
            // country: { type: 'String', editable: true, label: 'Country' },
            // postcode: { type: 'String', editable: true, label: 'Postcode' },
            //
            // Field: { type: 'RelatedType', editable: false, label: 'Fields', name: 'Fields', direction: PathDirection.child, edgeTypeId: 'Property_has_Fields_Field' },
            // Horse: { type: 'RelatedType', editable: false, label: 'Horses', name: 'Horse', direction: PathDirection.child, edgeTypeId: 'Property_has_HorsesHorse' },
        };
    }
}
exports.Property = Property;
